<!-- فرم کدینگ مراکز هزینه -->
<template>
  <div class="row">
    <div class="col-12 p-0">
      <div class="row p-0 d-flex justify-content-between align-items-center">
        <div class="col-4 p-0 pb-2">
          <div class="input-group p-0">
            <input
              id="textBaseUsePlaceSearch"
              placeholder="جستجو پیشرفته در لیست مراکز هزینه (Enter)"
              type="text"
              class="form-control form-control-sm rounded-0"
              v-on:focus="$event.target.select()"
              v-on:keyup.enter="searchData($event.target.value)"
            />
            <div class="input-group-prepend rounded-0">
              <span
                class="
                  input-group-text input-group-box-size
                  bg-secondary
                  rounded-left
                  white-text
                "
              >
                <a v-on:click="searchData('Search')">
                  <i class="fas fa-search"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
        <div
          class="col-4 p-0 pb-2 d-flex justify-content-end align-items-center"
        >
          <a
            class="
              btn btn-secondary btn-sm btn-floating
              p-0
              m-0
              d-flex
              justify-content-around
              align-items-center
            "
            style="width: 120px; height: 30px"
            title="ایجاد مرکز هزینه جدید"
            data-toggle="modal"
            data-target="#ModalAddNewBaseUsePlace"
          >
            مرکز هزینه جدید
            <i class="fas fa-plus fa-1x-half text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-sm text-center table-font-size">
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary">
          <td style="max-width: 50px">ردیف</td>
          <td>کد</td>
          <td>شرح</td>
          <td>تاریخ ثبت</td>
          <td>مدیریت</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="(row, index) in getTbBaseUsePlaceData">
            <tr
              :key="row.NCode"
              :class="{ selRow: SelectRowID == row.NCode }"
              v-on:click="SaveRowSelect(row)"
              v-bind:id="row.NCode"
              style="cursor: pointer"
            >
              <!-- ردیف -->
              <td
                style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ index + 1 }}
              </td>
              <!-- کد مرکز هزینه -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NCode }}
              </td>
              <!-- نام مرکز هزینه -->
              <td
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.SDesc }}
              </td>
              <!-- تاریخ ثبت مرکز هزینه -->
              <td
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.SDate }}
              </td>
              <!-- مدیریت -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  padding-left: 5px !important;
                  padding-right: 5px !important;
                "
              >
                <!-- منوی ویرایش مرکز هزینه -->
                <a
                  href="#"
                  title="ویرایش مرکز هزینه"
                  data-toggle="modal"
                  data-target="#ModalEditBaseUsePlace"
                >
                  <!-- <i class="far fa-eye fa-lg m-1 text-primary"></i> -->
                  <i class="fas fa-edit fa-lg m-1 text-success"></i>
                </a>
                <!-- منوی حذف مرکز هزینه -->
                <a
                  href="#"
                  title="حذف مرکز هزینه"
                  v-on:click="DeleteBaseUsePlace(row.NCode, row.SDesc)"
                >
                  <i class="far fa-trash-alt fa-lg m-1 pink-text"></i>
                </a>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <!-- مودال ثبت مرکز هزینه جدید -->
    <AddNewBaseUsePlace></AddNewBaseUsePlace>

    <!-- مودال ویرایش مرکز هزینه -->
    <EditBaseUsePlace
        v-bind:GetBaseUsePlace="SelectRowData"
    ></EditBaseUsePlace>

  </div>
</template>

<script>
import AddNewBaseUsePlace from "./Components/AddNewBaseUsePlace.vue";
import EditBaseUsePlace from "./Components/EditBaseUsePlace.vue"

export default {
  props: {
    // پراپرتی دریافت تب اکتیو
    tabID: { type: Number },
  },
  created() {
    // this.checkAccessUser();
  },
  components: {
    AddNewBaseUsePlace,
    EditBaseUsePlace,
  },
  data() {
    return {
      // آیدی سطر انتخاب شده
      SelectRowID: 1,
      // اطلاعات سطر انتخاب شده
      SelectRowData: {},
      // لیست محلی مراکز هزینه
      ListBaseUsePlace: [],
      // موارد جستجو شده قبلی
      NCodeSearch: [],
      // کنترل نمایش ویرایش اطلاعات پروفایل
      userDataForEditProfile: "",
    };
  },
  computed: {
    // دریافت اطلاعات لیست کاربران از مخزن
    getTbBaseUsePlaceData() {
      this.ListBaseUsePlace = this.$store.getters.getTbBaseUsePlaceData;
      return this.ListBaseUsePlace;
    },
  },
  methods: {
    // رویداد حذف مرکز هزینه
    async DeleteBaseUsePlace(NCode, SDesc) {
      swal({
        title: "تقاضای حذف مرکز هزینه",
        text: "آیا مرکز هزینه ( " + NCode + " - " + SDesc + " ) حذف شود ؟",
        icon: "warning", // success, warning, error, info
        buttons: {
          cancel: "انصراف",
          ok: "بله این مرکز هزینه ، حذف شود",
        },
      }).then(async (value) => {
        if (value) {
          // نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            notText: "حذف مرکز هزینه از سرور",
          });
          // دریافت توکن احراز هویت
          let token = await this.$store.getters.getUserData.token;
          var userData = await this.$store.dispatch(
            "DeleteBaseUsePlaceFromServer",
            { NCode, token }
          );
          // لغو نمایش لطفا صبر نمایید
          this.$store.dispatch("pleaseWait", {
            stop: true,
          });
        }
      });
    },

    // نگهداری اطلاعات سطر انتخاب شده
    SaveRowSelect(RowData) {
      this.SelectRowData = RowData;
      this.SelectRowID = RowData.NCode;
    },

    // جستجو در لیست مراکز هزینه
    searchData(searchValue) {
      if (searchValue === "Search") {
        searchValue =
          $("#textBaseUsePlaceSearch").val() != ""
            ? $("#textBaseUsePlaceSearch").val()
            : "";
      }
      if (searchValue != "") {
        let index = this.ListBaseUsePlace.findIndex(
          (item) =>
            (item.NCode.toString().startsWith(searchValue) ||
              item.SDesc.toString().includes(searchValue)) &&
            this.NCodeSearch.indexOf(item.NCode) == -1
        );
        if (index != -1) {
          let NCode = this.ListBaseUsePlace[index].NCode;
          $("#" + NCode).scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
          this.SelectRowID = NCode;
          this.SelectRowData = this.ListBaseUsePlace[index];

          this.NCodeSearch.push(NCode);
        } else {
          // موردی پیدا نشد : بازگشت به ابتدای جستجو
          this.NCodeSearch = [];
          $("#textBaseUsePlaceSearch").focus();
          $("#textBaseUsePlaceSearch").select();
          $("#textBaseUsePlaceSearch").scrollintoview({
            duration: 500,
            //complete: this.$store.dispatch("notify", { notText: "تست نمایش پیام !!", timeOut: 2500, });
          });
        }
      } else {
        this.$store.dispatch("notify", {
          notText: "مقداری برای جستجو درج نشده است !",
          timeOut: 2500,
        });
        this.NCodeSearch = [];
      }
    },
  },
};
</script>

<style scoped>
.selRow {
  background-color: #fbff94;
}
.rowBoxShadow {
  box-shadow: rgb(126 72 156 / 15%) 0px -2px 3px;
}
.tdGradient {
  background: linear-gradient(rgba(233, 233, 233, 0.4), rgba(255, 255, 255, 1));
}
.tdGradient2 {
  background: linear-gradient(
    rgba(233, 233, 233, 0.4),
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1)
  );
}
</style>


// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ListBaseUsePlace/ListBaseUsePlace.vue